import React, { useEffect, useState } from "react";
import { addMonths, addDays, startOfDay, endOfDay } from "date-fns";
import Flex from "./Flex";
import Text from "./Text";
import Input from "./Input";
import Modal from "./Modal";
import Button from "./Button";
import ReactDatePicker from "react-datepicker";

export type DateRange = [Date, Date];

export type DateRangeModalProps = {
  values: DateRange | null;
  onChange: (val: DateRange | null) => void;
  noNull: boolean;
  presets?: number[];
};

export function DateRangeModal({
  values,
  onChange,
  noNull,
  presets = [30, 60, 90],
}: DateRangeModalProps) {
  const [min, setMin] = useState<Date>(
    values?.[0] ?? addMonths(new Date(), -1),
  );
  const [max, setMax] = useState<Date>(values?.[1] ?? new Date());

  useEffect(() => {
    if (values == null) {
      setMin(addMonths(new Date(), -3));
      setMax(new Date());
    }
  }, [values]);

  const setVals = () => {
    onChange([min, max]);
  };

  const lastNDays = (days: number) => () =>
    onChange([startOfDay(addDays(new Date(), -days)), endOfDay(new Date())]);

  return (
    <Modal p={3} width={300}>
      <Flex alignItems="center" mb={3}>
        <ReactDatePicker
          selected={min}
          onChange={(d) => setMin(d as Date)}
          customInput={<Input />}
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          maxDate={max}
        />
        <Text pl={2} pr={2}>
          -
        </Text>
        <ReactDatePicker
          selected={max}
          onChange={(d) => setMax(d as Date)}
          minDate={min}
          showMonthDropdown
          showYearDropdown
          customInput={<Input />}
          dateFormat="dd/MM/yyyy"
        />
      </Flex>
      {presets.length > 0 && (
        <Flex flexDirection="column" mb={2}>
          {presets.map((x) => (
            <Button onClick={lastNDays(x)} mb={1} color="primary">
              {x === 0 ? "Today" : `Last ${x} Days`}
            </Button>
          ))}
        </Flex>
      )}
      <Flex>
        <Button onClick={setVals} style={{ flex: 1 }} color="primary">
          Set
        </Button>
        {!noNull && (
          <Button
            onClick={() => onChange(null)}
            ml={1}
            style={{ flex: 1 }}
            color="primary"
          >
            Clear
          </Button>
        )}
      </Flex>
    </Modal>
  );
}
